<template>
  <card>
    <div class="user-name">{{ userInfo.name }}</div>
    <div class="welcome">{{hoursTxt}}</div>
    <div class="user-role user-icon">{{$t("homepage.txt001")}}：{{ roleNames }}</div> <!-- 角色 -->
    <div class="user-dept user-icon">{{$t("homepage.txt002")}}：{{ userInfo.deptName }}</div> <!-- 部门 -->
  </card>
</template>

<script>
  import Card from './Card'
  import { mapGetters } from 'vuex'
  export default {
    name: "UserInfo",
    components: {
      Card
    },
    props: {
      hoursTxt: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
      }
    },
    computed: {
      ...mapGetters(['userInfo']),
      roleNames() {
        const { userRoleList } = this.userInfo
        return userRoleList.map(item => {
          return item.roleName
        }).join(',')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .user-info {
    .user-name {
      font-size: 18px;
      font-weight: bold;
    }
    .welcome {
      padding: 5px 0;
    }
    .user-icon {
      display: flex;
      align-items: center;
      &:before {
        display: inline-block;
        content: '';
        width: 18px;
        height: 18px;
        margin-right: 8px;
        background-repeat: no-repeat;
        -webkit-background-size: 100%;
        background-size: 100%;
      }
    }
    .user-role:before {
      background-image: url(~@/assets/img/icon/role.png);
    }
    .user-dept:before {
      background-image: url(~@/assets/img/icon/dept.png);
    }
  }
</style>
